module.exports = __webpack_public_path__ + "dingbeauty-landing/img/system_05.07ba8bbd.jpg";